module.exports = __webpack_public_path__ + "static/media/Evelynn.0ab83737.png";